/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import WholeMeLoadingCircle from 'pages/wholeme/molecules/wholeMeLoadingCircle/WholeMeLoadingCircle';
import WholeMeProfileIdentity from 'pages/wholeme/molecules/wholeMeProfileIdentity/WholeMeProfileIdentity';
import { useHistory } from 'react-router';
import { Stack, Tab, Tabs } from '@mui/material';
import Goals from 'pages/backr/goals/Goals';
import AccountSettings from '../../../../profile/AccountSettings';
import WholeMeProfileProtected from './WholeMeProfileProtected';
import LockedProfile from '../../../molecules/lockedProfile/LockedProfile';
import BlockedProfileIdentity from '../../../molecules/blockedProfile/BlockedProfileIdentity';
import WholeMeProfileStory from './WholeMeProfileStory';
import { resolveShowStoryTab } from './utils';

const profileBlockedReasons = ['BLOCKED', 'FLAGGED'];

const WholeMeProfile = ({
  userId,
  viewingUser,
  wholeMeClient,
  legacyProfileData,
  isViewingAdmin,
  profilePermissions,
  userPermissions,
  setIsLoading,
  isLoading,
  refreshProfile,
  initialMode = 'profile',
}) => {
  const [profile, setProfile] = useState(null);
  const [mode, setMode] = useState(initialMode);
  const [profileLoaded, setProfileLoaded] = useState(false);
  const history = useHistory();
  const editable = profilePermissions?.edit_profile?.allowed && !isViewingAdmin;
  const showGoalsTab = !profilePermissions?.edit_profile?.allowed && !isViewingAdmin && (profile?.goals?.[0]?.count > 0);
  const tabMarginRight = '30px';
  const showStoryTab = resolveShowStoryTab(profile, editable);
  const renderTabs = (showStoryTab || showGoalsTab || editable);

  useEffect(() => {
    if (!profilePermissions) {
      return;
    }

    if (profilePermissions?.view_protected_profile?.allowed) {
      setIsLoading(true);
      wholeMeClient.fetchProfile(userId).then((fetched) => {
        setProfile({
          id: userId,
          ...fetched,
        });
      }).finally(() => {
        setIsLoading(false);
        setProfileLoaded(true);
      });
    } else {
      setProfileLoaded(true);
    }
  }, [profilePermissions]);

  const renderLoadingScreen = isLoading || !profileLoaded;

  if (renderLoadingScreen) {
    return (
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <WholeMeLoadingCircle />
      </div>
    );
  }

  const onEdit = editable
    ? (categoryId, stepId) => {
      if (!stepId) {
        history.push(`/wholeme/wizard/${categoryId}`);
      } else {
        history.push(`/wholeme/wizard/${categoryId}/${stepId}`);
      }
    }
    : undefined;

  const onStoryChange = () => {
    wholeMeClient.fetchProfile(userId).then((fetched) => {
      setProfile(fetched);
    });
  };

  const handleTabChange = (_e, value) => {
    setMode(value);
  };

  const nonRestrictedProfileData = {
    first_name: legacyProfileData?.first_name,
    last_name: legacyProfileData?.last_name,
    role: legacyProfileData?.role,
    roles: legacyProfileData?.roles,
    profile_image: legacyProfileData?.profile_image,
  };

  const composedProfile = {
    ...profile || {},
    ...nonRestrictedProfileData,
    relationshipStatus: legacyProfileData?.relationshipStatus,
    donorboxId: legacyProfileData?.donorbox_id,
  };

  const restrictedProfileReason = profilePermissions?.view_protected_profile?.reason;
  const profileMessage = profilePermissions?.view_protected_profile?.message;

  const getLockedProfileVariant = () => {
    let lockedProfileVariant = 'unavailable';

    if (profileMessage === 'UNAVAILABLE') {
      return lockedProfileVariant;
    }
    lockedProfileVariant = profileBlockedReasons.includes(restrictedProfileReason) ? 'blocked' : 'unlock';
    return lockedProfileVariant;
  };

  const RenderIdentity = profilePermissions?.view_public_profile ? (
    <WholeMeProfileIdentity
      key={userId}
      profile={composedProfile}
      onEdit={onEdit}
      isViewingAdmin={isViewingAdmin}
      permissions={profilePermissions}
      userPermissions={userPermissions}
      refreshProfile={refreshProfile}
    />
  ) : (
    <BlockedProfileIdentity />
  );

  const RenderProfile = profilePermissions?.view_protected_profile?.allowed ? (
    <WholeMeProfileProtected
      profile={profile}
      wholeMeClient={wholeMeClient}
      editable={editable}
      onEdit={onEdit}
      isViewingAdmin={isViewingAdmin}
      legacyProfileData={legacyProfileData}
    />
  ) : (
    <LockedProfile variant={getLockedProfileVariant()} />
  );

  return (
    <Stack sx={{ padding: '20px' }} spacing={1}>
      {profilePermissions?.view_protected_profile?.allowed && renderTabs && (
        <Tabs value={mode} onChange={handleTabChange}>
          <Tab value="profile" label="Profile" style={{ marginRight: tabMarginRight }} />
          {showGoalsTab && <Tab value="goals" label="Goals" style={{ marginRight: tabMarginRight }} />}
          {showStoryTab && <Tab value="story" label="Story" style={{ marginRight: showGoalsTab ? 0 : tabMarginRight }} />}
          {editable && <Tab value="account" label="Account" />}
        </Tabs>
      )}
      {mode === 'profile' && (
        <Stack spacing={1.5}>
          {RenderIdentity}
          {RenderProfile}
        </Stack>
      )}
      {mode === 'account' && <AccountSettings user={viewingUser} />}
      {mode === 'story' && (
      <WholeMeProfileStory
        profile={profile}
        onStoryChange={onStoryChange}
        editable={editable}
        onEdit={onEdit}
      />
      )}
      {mode === 'goals' && <Goals showHeader={false} userId={userId} />}
    </Stack>
  );
};

export default WholeMeProfile;
